<template>
  <section class="text-question-component">
    <span class="slide-number title mb-4">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <p>
      {{ activity.logged_answers }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'TextQuestion',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
.text-question-component {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }
}
</style>
